import { useEffect, useState } from 'react';

import { getCurrentUserInfo } from '../../../utils/auth';
import getAddressFromId from '../../../utils/getAddressFromId';
import { StyledSemiboldLabel } from '../../Styled';

import InformationPanel from './InformationPanel';

const AccountInformation = () => {
  const [currentUserInfo, setCurrentUserInfo] = useState(undefined);

  useEffect(() => {
    getCurrentUserInfo().then((res) => setCurrentUserInfo(res));
  }, []);

  return (
    <InformationPanel title="Account information" isLoading={!currentUserInfo}>
      <li>
        <StyledSemiboldLabel>Name:</StyledSemiboldLabel> {currentUserInfo?.attributes?.name}
      </li>
      <li>
        <StyledSemiboldLabel>Address:</StyledSemiboldLabel>{' '}
        {currentUserInfo?.attributes?.address && getAddressFromId(currentUserInfo?.attributes?.address)}
      </li>
      <li>
        <StyledSemiboldLabel>Email address:</StyledSemiboldLabel> {currentUserInfo?.attributes?.email}
      </li>
      <li>
        <StyledSemiboldLabel>Password:</StyledSemiboldLabel> ••••••••
      </li>
    </InformationPanel>
  );
};

export default AccountInformation;
